var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUlx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 13,
    viewBox: "0 0 44 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.67241 12.6172L5.89641 4.12119H7.70441L9.48841 11.9132L9.08041 11.9292L10.1924 4.12119H12.7524L11.0564 12.6172H7.67241ZM1.76841 12.6172L0.0724072 4.12119H2.63241L3.74441 11.9292L3.34441 11.9132L5.11241 4.12119H6.92041L5.16041 12.6172H1.76841ZM23.1098 8.35319C23.1098 9.84652 22.7151 10.9639 21.9258 11.7052C21.1364 12.4412 20.0564 12.8092 18.6858 12.8092C17.3098 12.8092 16.2271 12.4412 15.4378 11.7052C14.6538 10.9639 14.2618 9.84652 14.2618 8.35319C14.2618 8.15052 14.2618 7.93452 14.2618 7.70519C14.2618 7.47585 14.2618 7.23585 14.2618 6.98519V0.817187H16.7498V7.33719C16.7498 7.53985 16.7498 7.72919 16.7498 7.90519C16.7498 8.08119 16.7498 8.24385 16.7498 8.39319C16.7498 9.22519 16.9018 9.83852 17.2058 10.2332C17.5098 10.6225 18.0031 10.8172 18.6858 10.8172C19.3631 10.8172 19.8564 10.6225 20.1658 10.2332C20.4751 9.83852 20.6298 9.22519 20.6298 8.39319V0.817187H23.1098V8.35319ZM25.3943 12.6172V0.817187H27.8823V11.8732L26.7623 10.5932H32.2743V12.6172H25.3943ZM37.4638 5.77719L37.4478 7.78519L33.6238 0.817187H36.4158L38.9678 6.12919H37.9838L40.5118 0.817187H43.3038L39.5198 7.78519L39.5038 5.77719L43.4238 12.6172H40.6238L37.9438 7.43319H38.9998L36.3198 12.6172H33.5278L37.4638 5.77719Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUlx);
export default __webpack_public_path__ + "static/media/ULX.a2ca3f55554c5582b6c89a08a0920bff.svg";
export { ForwardRef as ReactComponent };